import './App.css';

import { useEffect, useRef, useCallback } from "react";
import Chat from "./components/chat";
import { FINISH_SESSION_URL, getDemochatAuthHeaders } from './apiConfig';

const CONVERSATION_DRAFT_KEY = "conversationDraft";

function App() {
  const conversationRef = useRef([]);
  const hasFinishedRef = useRef(false);
  const inFlightRef = useRef(false);

  const buildFinishPayload = useCallback(() => {
    const messages = (conversationRef.current || []).map((m) => ({
      role: m.role,
      content: m.content ?? '',
      data: m.content ?? ''
    }));
    return {
      status: "finish",
      data: messages,
      sessionEnd: new Date().toISOString()
    };
  }, []);

  const saveConversationDraft = useCallback(() => {
    const messages = conversationRef.current || [];
    if (messages.length === 0) return;
    try {
      localStorage.setItem(CONVERSATION_DRAFT_KEY, JSON.stringify({
        data: messages,
        updatedAt: new Date().toISOString()
      }));
    } catch {
      /* quota exceeded or blocked */
    }
  }, []);

  const sendFinishSession = useCallback(async (payload) => {
    const body = JSON.stringify(payload);

    if (typeof fetch !== 'undefined') {
      try {
        const response = await fetch(FINISH_SESSION_URL, {
        method: "POST",
        headers: getDemochatAuthHeaders(),
        body,
        keepalive: true
      });

        if (response.status === 401 || response.status === 403) {
          console.warn("[finishSession] Authorization failed", response.status);
        } else if (!response.ok) {
          console.error("[finishSession] Request failed", response.status);
        }
      } catch (error) {
        console.error("[finishSession] Failed to send finish payload", error);
      }
    } else {
      console.warn("[finishSession] fetch API is unavailable");
    }
  }, []);

  useEffect(() => {
    const handleUnload = () => {
      if (hasFinishedRef.current) return;
      if ((conversationRef.current || []).length === 0) return;
      const payload = buildFinishPayload();
      hasFinishedRef.current = true;
      sendFinishSession(payload);
    };

    const handlePageHide = (event) => {
      if (event.persisted) return;
      handleUnload();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        handleUnload();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("pagehide", handlePageHide);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("pagehide", handlePageHide);
    };
  }, [buildFinishPayload, sendFinishSession]);

  return (
    <div className="App">
      <header className="App-header">
        <Chat
          contextRef={conversationRef}
          onConversationChange={saveConversationDraft}
          onInFlightChange={(v) => { inFlightRef.current = v; }}
        />
      </header>
    </div>
  );
}

export default App;
